<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <header>
                <h3> {{sistemaService.NombrePantallaActual}}: Importar </h3>
            </header>

            <div class="divisor16"></div>

            <div class="row margen">
                <div class="col-12">
                    <!-- Tipo y archivo -->
                    <div class="row">

                         <ng-container>
                            <!-- Archivo -->
                            <div class="col-lg-4 col-md-6 col-sm-8 col-9 ">
                                <fileCustom [titulo]="'Layout'" (archivoSeleccionado)="archivo = $event" [errorActivo]="errorActivo" [mimeTypeAceptado]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"></fileCustom>
                            </div>

                            <!-- botón importar -->
                            <div class="col-lg-8 col-md-6 col-sm-4 col-3 ">
                                 <button (click)="ValidarArchivo()" class="boton botonSM filled">
                                    {{'Importar'}}
                                </button>
                            </div>
                        </ng-container>

                    </div>

                    <div class="row"><div class="col-12"><div class="separadorTop0"></div></div></div>

                    <ng-container *ngIf="estatusProceso != ProcesoSIConvertEnum.Inico">

                        <div class="row margen">

                            <!-- Avance -->
                            <div class="col-12 col-md-6">

                                <!-- Título -->
                                <div class="row">
                                    <div class="col-12">
                                        <span class="tituloSeccionSI">{{'Layout.Importacion.Proceso' | translate}}</span>
                                    </div>
                                </div>

                                <div class="divisor24"></div>

                                <!-- Pasos -->
                                <div class="row">
                                    <div class="col-12" *ngFor="let paso of pasos">

                                         <div class="paso">

                                            <!-- icono -->
                                            <div class="icono">
                                                <ng-container *ngTemplateOutlet="iconoEstatusPaso;context:paso"></ng-container>
                                            </div>

                                            <!-- descipción -->
                                            <div class="texto" [ngClass]="{'enEspera' : paso.Estatus == EstatusProcesoEnum.Pendiente}">
                                                 <span>{{paso.Titulo}}</span>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div class="divisor16"></div>

                                <!-- Mensaje Error -->
                                <ng-container *ngIf="estatusProceso == ProcesoSIConvertEnum.Error">
                                    <div class="row">
                                        <div class="col-12">

                                            <div class="mensajeProceso">
                                                <svg-icon class="iconoProceso" src="assets/Icono/error.svg"></svg-icon>
                                                <div class="divisor12"></div>
                                                <div class="mensaje"><span>{{'Layout.Importacion.Error' | translate}}</span></div>
                                            </div>

                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Mensaje finalizado -->
                                <ng-container *ngIf="estatusProceso == ProcesoSIConvertEnum.Finalizado">
                                    <div class="row">
                                        <div class="col-12">

                                            <div class="mensajeProceso">
                                                <svg-icon class="iconoProceso" src="assets/Icono/success.svg"></svg-icon>
                                                <div class="divisor12"></div>
                                                <div class="mensaje"><span>{{'Layout.Importacion.Finalizado' | translate}}</span></div>
                                            </div>

                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Mensaje validado -->
                                <ng-container *ngIf="estatusProceso == ProcesoSIConvertEnum.EnEspera">
                                    <div class="row">
                                        <div class="col-12">

                                            <div class="mensajeProceso">
                                                <svg-icon class="iconoProceso" src="assets/Icono/success.svg" *ngIf="importacion.Correctos > 0"></svg-icon>
                                                <svg-icon class="iconoProceso" src="assets/Icono/sinRegistros.svg" *ngIf="importacion.Correctos == 0"></svg-icon>
                                                <div class="divisor12"></div>
                                                <div class="mensaje" *ngIf="importacion.Correctos > 0"><span>{{'Layout.Importacion.Verificado' | translate}}</span></div>
                                                <div class="mensaje" *ngIf="importacion.Correctos == 0"><span>{{'Layout.Importacion.SinRegistrosImportar' | translate}}</span></div>
                                                <div class="divisor12"></div>
                                                <div>
                                                    <button class="btn boton filled redondeado botonSM" style="min-width: 230px" (click)="ImportarDatos(0)" [ngClass]="{'disabled' : importacion.Correctos == 0}">
                                                        {{'Layout.Importacion.ImportarDatos' | translate}}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </ng-container>

                            </div>

                            <!-- Resultado -->
                            <div class="col-12 col-md-6">
                                <!-- Título -->
                                <div class="row">
                                    <div class="col-12">
                                        <span class="tituloSeccionSI">{{'Layout.Importacion.Resultado' | translate}}</span>
                                    </div>
                                </div>

                                <div class="divisor24"></div>

                                <div class="row">
                                    <div class="col-12">
                                        <table class="datosResultados">
                                            <tr>
                                                <td class="tituloResultado primertituloResultado">{{'Layout.ResultadosAnalisis.Encontrados' | translate}}</td>
                                                <td class="primertituloResultado">{{importacion.Registros}}</td>
                                            </tr>

                                            <tr>
                                                <td class="tituloResultado">{{'Layout.ResultadosAnalisis.Correctos' | translate}}</td>
                                                <td>{{importacion.Correctos}}</td>
                                            </tr>

                                            <tr>
                                                <td class="tituloResultado">{{'Layout.ResultadosAnalisis.Incorrectos' | translate}}</td>
                                                <td>{{importacion.Incorrectos}}</td>
                                            </tr>

                                            <tr>
                                                <td class="tituloResultado">{{'Layout.ResultadosAnalisis.Omitidos' | translate}}</td>
                                                <td>{{importacion.Omitidos}}</td>
                                            </tr>

                                        </table>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row"><div class="col-12"><div class="separador"></div></div></div>

                        <!-- Errores -->
                        <ng-container *ngIf="importacion.Errores.length > 0">
                            <!-- Título -->
                            <div class="row">
                                <div class="col-12">
                                    <span *ngIf="pasos[1].Estatus == EstatusProcesoEnum.Error" class="tituloSeccionSI">{{'Layout.Importacion.Errores' | translate}}</span>
                                    <span *ngIf="pasos[1].Estatus == EstatusProcesoEnum.Success" class="tituloSeccionSI">Advertencias</span>
                                </div>
                            </div>

                            <div class="divisor16"></div>

                            <dx-data-grid
                                (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                id="erroresTabla"
                                [columnAutoWidth]="true"
                                [dataSource]="importacion.Errores"
                                [showColumnHeaders]="true">

                                <dxo-export [enabled]="true" [fileName]="'Layout.Importacion.Errores' | translate"></dxo-export>

                                <dxo-search-panel
                                    [visible]="true"
                                    [width]="240"
                                    placeholder="Buscar">
                                </dxo-search-panel>

                                <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>

                                <dxo-pager
                                    [visible]="true"
                                    [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                    [displayMode]="sistemaService.tablaPaginacionModo"
                                    [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                    [showInfo]="sistemaService.tablaPaginacionInfo"
                                    [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                </dxo-pager>

                                <dxi-column
                                    dataField="Fila"
                                    caption="{{'Layout.ErroresTabla.Fila' | translate}}"
                                    alignment="center">
                                </dxi-column>

                                <dxi-column
                                    dataField="Celda"
                                    caption="{{'Layout.ErroresTabla.Celda' | translate}}"
                                    alignment="center">
                                </dxi-column>

                                <dxi-column
                                    dataField="Dato"
                                    caption="{{'Layout.ErroresTabla.Dato' | translate}}"
                                    alignment="center">
                                </dxi-column>

                                <dxi-column
                                    dataField="Descripcion"
                                    caption="{{'Layout.ErroresTabla.Descripcion' | translate}}"
                                    alignment="center">
                                </dxi-column>

                            </dx-data-grid>
                        </ng-container>

                    </ng-container>
                </div>
            </div>

            <div class="divisor20"></div>
            <div class="row margen">
                <div class="col-12">
                    <div class="panelBotonesFiltro">
                        <button class="boton botonSM filledBlanco" (click)="Salir()" 
                                *ngIf="estatusProceso != ProcesoSIConvertEnum.Inico && estatusProceso != ProcesoSIConvertEnum.Error && estatusProceso != ProcesoSIConvertEnum.Finalizado">
                                {{'Cancelar'}} </button>

                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()" 
                                *ngIf="estatusProceso == ProcesoSIConvertEnum.Inico || estatusProceso == ProcesoSIConvertEnum.Error || estatusProceso == ProcesoSIConvertEnum.Finalizado">
                                {{'Cerrar'}} </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>

<ng-template #iconoEstatusPaso let-estatus="Estatus">
    <svg-icon class="iconoSVGSI pendiente" src="assets/Icono/enEspera.svg" *ngIf="estatus == EstatusProcesoEnum.Pendiente"></svg-icon>
    <div *ngIf="estatus == EstatusProcesoEnum.Procesando" class="procesandoSI"><svg-icon class="iconoSVGSI" src="assets/Icono/procesando.svg" ></svg-icon></div>
    <svg-icon class="iconoSVGSI success" src="assets/Icono/success.svg" *ngIf="estatus == EstatusProcesoEnum.Success"></svg-icon>
    <svg-icon class="iconoSVGSI error" src="assets/Icono/error.svg" *ngIf="estatus == EstatusProcesoEnum.Error"></svg-icon>
</ng-template>
